module.exports = __webpack_public_path__ + "img/34265-096.ed622224.jpg";